import { WSTable } from "@wingspanhq/fe-component-library";
import { Role, Stakeholder } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";
import { getColumns } from "./columns";

export type TableItemData = Stakeholder;

type Props = {
  stakeholders: Stakeholder[];
  roles: Role[];
  loading?: boolean;
  canManage?: boolean;
  onEdit?: (stakeholder: Stakeholder) => void;
  onRevoke?: (stakeholder: Stakeholder) => void;
};

export const TableStakeholders: React.FC<Props> = props => {
  const tableData = useMemo(
    () =>
      props.stakeholders.map(stakeholder => ({
        id: stakeholder.id as string,
        data: stakeholder
      })),
    [props.stakeholders]
  );

  const roleNameById = useMemo(
    () => new Map(props.roles.map(role => [role.id, role.name])),
    [props.roles]
  );

  const columns = useMemo(() => getColumns({ roleNameById }), [roleNameById]);

  return (
    <WSTable<TableItemData>
      loading={props.loading}
      showHeader={tableData.length > 0}
      columns={columns}
      tableData={tableData}
      rowMenuActions={
        props.canManage
          ? ({ data }) => [
              {
                label: "Edit",
                onClick: () => props.onEdit?.(data)
              },
              {
                label: "Delete",
                onClick: () => props.onRevoke?.(data)
              }
            ]
          : undefined
      }
    />
  );
};
